import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { CaregiverRoleEnum, CaregiverSpecialization } from '@/shared/enums';

export const searchAtom = atom<string>('');
export const dateAtom = atom<Date>();
export const showMyConsultationsAtom = atom<boolean>(true);

export const isCaregiverLeadAtom = atom<boolean>(false);
export const userIdAtom = atom<number>();

export const documentTitleAtom = atom<string>();
export const caregiverRoleAtom = atom<CaregiverRoleEnum>();
export const caregiverSpecializationsAtom = atom<CaregiverSpecialization[]>([]);

export const isAdolescentEnabledAtom = atom<boolean>(false);
export const adolescentMinimumAgeAtom = atom<number>();
export const adultMinimumAgeAtom = atom<number>();
export const selectedWaitingRoomRoleAtom = atom<
    CaregiverRoleEnum | undefined
>();

export const isSoundDisabledAtom = atomWithStorage(
    'isSoundDisabledForConsultationList',
    false,
);

export const showPhrasesInfoBoxAtom = atomWithStorage(
    'showPhrasesInfoBox',
    true,
);

export const isNotepadOpenAtom = atom<boolean>(false);
